import { render, staticRenderFns } from "./reexaminationReviewInfo.vue?vue&type=template&id=1b864f74&scoped=true"
import script from "./reexaminationReviewInfo.vue?vue&type=script&lang=js"
export * from "./reexaminationReviewInfo.vue?vue&type=script&lang=js"
import style0 from "./reexaminationReviewInfo.vue?vue&type=style&index=0&id=1b864f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b864f74",
  null
  
)

export default component.exports